import { site } from '../data/site'

/**
 * Builds a click-to-text link that opens the visitor's messaging app with a
 * pre-written message. iOS needs `&body=`, Android needs `?body=` — the
 * `&` form after a `?` works across both.
 */
export function smsLink(message: string): string {
  return `sms:${site.smsNumber}?&body=${encodeURIComponent(message)}`
}

export const smsMessages = {
  general: 'Hi Hydrosprings — I have a question about going chemical-free.',
  quote: 'Hi Hydrosprings — I\u2019d like a quote. My pool is about ____ gallons.',
  call: 'Hi Hydrosprings — can someone call me about a chemical-free system?',
  install: 'Hi Hydrosprings — I\u2019d like to know about install timing in my area.',
  commercial: 'Hi Hydrosprings — I\u2019m asking about a commercial property.',
  product: (name: string, capacity: string) =>
    `Hi Hydrosprings — what\u2019s the price on the ${name} (${capacity})?`,
}
